<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/sale/receipts">{{$t('sale_receipt')}}</router-link>
            </li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button> 
            <b-btn variant="outline-primary no-bor" size="sm" @click="onSave"><i class="fa fa-floppy-o" aria-hidden="true"></i> {{$t('save')}}</b-btn>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="form-group" :class="{ 'form-group-error': $v.header.CustomerId.$error }">
                                <label class="label-control blue">{{$t('customer')}}</label>
                                <div>
                                    <CustomerDropdown @select="customerSelected" :include-add-new="false" :value="header.CustomerName" place="Choose a customer"></CustomerDropdown>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group" :class="{ 'form-group-error': $v.header.Num.$error }">
                                <label class="label-control blue">{{$t('receipt_no')}}</label>
                                <div>
                                    <input type="text" class="form-control form-control-sm" v-model="$v.header.Num.$model" readonly/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group" :class="{ 'form-group-error': $v.date.$error }">                                
                                <DatePicker v-model="$v.date.$model" :label="$t('date')"/>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="label-control blue">{{$t('payment_method')}}</label>
                                <div>
                                    <select class="form-control form-control-sm" v-model="header.PaymentMethodId">
                                        <option value=""></option>
                                        <option v-for="(ret,index) in paymentMethods" :value="ret.Id" :key="index">{{ret.Name}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group" :class="{ 'form-group-error': $v.header.AccountId.$error }">
                                <label class="label-control blue">{{$t('deposit_to_account')}}</label>
                                <div>
                                    <select class="form-control form-control-sm" v-model="$v.header.AccountId.$model">
                                        <option value=""></option>
                                        <option v-for="(ret,index) in banks" :value="ret.Id" :key="index">{{ret.Name}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label class="label-control blue">{{$t('text_amount')}}</label>
                                <div>
                                    <input type="text" class="form-control form-control-sm" readonly v-model="header.TextAmount">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table table-bordered table-sm no-bor">
                                <thead>
                                    <tr>
                                        <th class="text-center" style="width: 40px;"><input type="checkbox" v-model="isCheckAll"/></th>
                                        <th>កាលបរិច្ឆេទ</th>
                                        <th>លេខវិក្កយបត្រ</th>
                                        <th>{{$t('due_date')}}</th>
                                        <th class="text-right" style="width: 150px;">{{$t('original_amount')}}</th>
                                        <th class="text-right" style="width: 150px;">{{$t('open_balance')}}</th>
                                        <th class="text-right" style="width: 150px;">{{$t('payment')}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(ret,index) in lines" :key="index">
                                        <td class="text-center"><input type="checkbox" v-model="ret.Checked" @change="isCheck(ret)"/></td>
                                        <td>{{$format(ret.InvoiceDate,'DD/MM/YYYY')}}</td>
                                        <td>{{ret.TaxNum}}</td>
                                        <td>{{$format(ret.InvoiceDueDate,'DD/MM/YYYY')}}</td>
                                        <td class="text-right">{{$money(ret.OriginalAmount)}}</td>
                                        <td class="text-right">{{$money(ret.Balance)}}</td>
                                        <td class="cell-input">
                                            <input type="text" class="form-control form-control-sm text-right" v-model="ret.ReceiveAmount" @blur="calculate" style="font-size: 14px;">
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colspan="6" class="text-right">ទឹកប្រាក់សរុប</td>
                                        <td class="text-right">{{$money(header.Amount)}}</td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <b-form-group class="label-control blue" :label="$t('description')">
                                <b-form-textarea v-model="header.Description"/>
                            </b-form-group>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
import { Sale } from '../../shared/models/model';
import { CustomerDropdown } from '../Customer';
import { ToWords } from 'to-words';
import DatePicker from '../Components/DatePicker'
export default {
    components: { CustomerDropdown, DatePicker },
    data: function(){
        return {
            header: {
                Num: '',
                CustomerId: '',
                CustomerName: '',
                Date: this.$now().format('DD-MM-YYYY'),
                AccountId: '',
                Amount: 0
            },
            lines: [],
            banks: [],
            paymentMethods: [],
            isUpdate: false,
            isCheckAll: false
        }
    },
    validations:{
        header: {
            Num: { required },
            CustomerId: { required },            
            AccountId: { required }
        },
        date: { required },
    },
    created(){
        this.init();
    },
    methods: {
        init(){
            let loading = this.$loading.show();
            let req = {
                CompanyId: this.$store.state.company.Id,
                Statuses: ['Bank','Other Current Asset']
            };
            let id = this.$route.params.id;
            if(!this.$isEmpty(id)){
                req.Id = id;
            }
            this.$api().post('receipt/init-form', req).then(res => {
                if(this.$isValid(res)){
                    let json = res.data.Json;
                    this.banks = json.Accounts;
                    this.paymentMethods = json.Methods;
                    if(!this.$isEmpty(id)){
                        this.header = json.Header;
                        this.date = this.header.Date;
                        this.lines = res.Json.Lines;
                    }else{
                        this.header.Num = json.Header.Num;
                    }
                }
            }).finally(() => { loading.hide(); });
        },
        onSave(){
            this.$v.$touch();
            if (!this.$v.$invalid) {
                let lines = this.lines.filter(el => el.Checked == true);
                if(lines.length == 0){
                    this.$swal.fire('សារបញ្ជាក់', 'សូមធ្វើការជ្រើសរើសវិក្កយបត្រលក់យ៉ាងតិច១។', 'warning');
                    return;
                }
                this.header.Date = this.date;
                this.header.CompanyId = this.$store.state.company.Id;
                this.header.ClientId = this.$store.state.company.ClientId;
                var req = {
                    Header: this.header,
                    Lines: lines
                };
                var loading = this.$loading.show();
                Sale.saveReceipt(req, this.isUpdate).then(() => {
                    this.$router.go(-1);
                }).finally(() => { loading.hide(); });
            }
        },
        customerSelected(e){
            this.header.CustomerId = e.data.Id;
            this.header.CustomerName = e.data.KhmerName;
            let req = {
                CustomerId: e.data.Id
            };
            var loading = this.$loading.show();
            Sale.selectInvoicePaid(req).then(res => {
                this.lines = res.Json.Lines;
            }).finally(() => { loading.hide(); });
        },
        calculate(){
            let total = 0;
            let desc = [];
            this.lines.forEach(el => {
                if(el.ReceiveAmount > 0 && !el.Checked) el.Checked = true;
                total += Number(el.ReceiveAmount);
                if(el.Checked){
                    let msg = el.TaxNum;
                    if(el.Balance - el.ReceiveAmount == 0)
                        msg += '(Paid)';
                    else msg += '(Partially)';
                    desc.push(msg);
                }
            });
            this.header.Amount = total;
            this.header.Description = 'Payment for invoice no: ' + desc.join(', ');
            this.toTextAmount();
        },
        isCheck(item){
            if(item.Checked) item.ReceiveAmount = item.Balance;
            else item.ReceiveAmount = 0;
            this.calculate();
        },
        toTextAmount(){
            const toWords = new ToWords({localeCode: 'en-US'});
            this.header.TextAmount = toWords.convert(this.header.Amount, { currency: true });
        }
    },
    watch: {
        isCheckAll(value){
            this.lines.forEach(el => {
                el.Checked = value;
                if(el.Checked) el.ReceiveAmount = el.Balance;
                else el.ReceiveAmount = 0;
            });
            this.calculate();
        }
    }
}
</script>